module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2023_10.46d81473.webp";